<template>
  <b-modal
    :id="modal.id"
    v-model="modal.show"
    size="md"
    centered
    scrollable
    no-fade
    :hide-header="!$slots.title"
    header-class="align-items-center"
    :header-bg-variant="headerBgVariant"
    :header-text-variant="headerTextVariant"
    title-class="h3"
  >
    <template #modal-header-close><b-icon icon="close" scale="0.75"/></template>
    <template #modal-title>
      <slot name="title"/>
    </template>

    <slot/>

    <template #modal-footer>
      <slot name="actions" :abort="close" :confirm="navigateToLink"/>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ExternallinkModal',
  props: {
    headerBgVariant: {
      type: String,
      default: 'dark'
    },
    headerTextVariant: {
      type: String,
      default: 'light'
    }
  },
  data () {
    return {
      modal: {
        id: this.$options.name,
        show: false,
        href: null
      }
    }
  },
  methods: {
    open (href) {
      this.modal.href = href
      this.modal.show = true
    },
    close () {
      this.modal.show = false
      this.modal.href = null
    },
    navigateToLink () {
      window.location.href = this.modal.href
    }
  },
  created () {
    this.$root.$on('externallinkmodal:show', this.open)
  }
}
</script>

<style lang="scss"></style>
